import * as TYPES from './types';
export const menuRoutes = {
  ADMIN: '/admin',
  ARTISTAS: '/artists',
  CATEGORIES: '/categories',
  PEDIDOS: '/pedidos',
  SETTINGS: '/settings',
  SIGNOUT: '/signout',
};

export const menuItens: TYPES.MenuItemInterface[] = [
  { name: 'Artistas', icon: 'fa fa-users', route: menuRoutes.ARTISTAS },
  { name: 'Categorias', icon: 'fa fa-list', route: menuRoutes.CATEGORIES },
  { name: 'Pedidos', icon: 'fa fas fa-comments-dollar', route: menuRoutes.PEDIDOS },
  { name: 'Admin', icon: 'fas fa-user-cog', route: menuRoutes.ADMIN },
  { name: 'Configurações', icon: 'fa fa-cogs', route: menuRoutes.SETTINGS },
  { name: 'Sair', icon: 'fas fa-sign-out-alt', route: menuRoutes.SIGNOUT },
];
